import createTheme from "@mui/material/styles/createTheme";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      default: "#121820", // Fond principal très sombre
      paper: "#1E2638", // Fond des cartes et éléments de liste
    },
    primary: {
      main: "#4FC3F7", // Bleu cyan pour le bouton '+' et les actions principales
      contrastText: "#000000",
    },
    text: {
      primary: "#E0E6ED", // Texte principal (Kanji / Furigana)
      secondary: "#94A3B8", // Traduction et sous-titres
    },
    divider: "#2D3748",
  },
  typography: {
    fontFamily: '"Inter", "Noto Sans JP", "Roboto", "Helvetica", "Arial", sans-serif',
    h6: {
      fontWeight: 600,
      letterSpacing: "0.5px",
    },
  },
  shape: {
    borderRadius: 12, // Bords arrondis légers identiques au design
  },
  components: {
    // Style personnalisé pour les cartes de chaque mot
    MuiPaper: {
      styleOverrides: {
        rounded: {
          backgroundImage: "none", // Supprime le survol gris par défaut de MUI dark mode
          border: "1px solid #2A3447",
        },
      },
    },
    // Style du champ de recherche en haut
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: "#1A2232",
          borderRadius: 24,
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#2D3748",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#4FC3F7",
          },
        },
      },
    },
    // Case à cocher pour la sélection
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: "#64748B",
          "&.Mui-checked": {
            color: "#4FC3F7",
          },
        },
      },
    },
  },
});

export default darkTheme;
